import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faCheck } from '@fortawesome/free-solid-svg-icons';
// import CheckInCalendar from './CheckInCalendar';

const CheckInManager = () => {
    const [checkIns, setCheckIns] = useState([]);
    const [newCheckIn, setNewCheckIn] = useState({ name: '', rewardId: null });
    const [editingCheckIn, setEditingCheckIn] = useState(null);
    const [error, setError] = useState(null);
    const location = useLocation();
    const checkInRefs = useRef({});

    useEffect(() => {
        fetchCheckIns();
    }, []);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const checkInId = query.get('checkInId');
        if (checkInId && checkInRefs.current[checkInId]) {
            checkInRefs.current[checkInId].scrollIntoView({ behavior: 'smooth' });
        }
    }, [checkIns, location.search]);

    const fetchCheckIns = async () => {
        try {
            console.log('获取所有打卡记录...');
            const response = await axios.get('/checkIns');
            setCheckIns(response.data);
            console.log('获取的打卡记录:', response.data);
        } catch (err) {
            console.error('获取打卡记录时出错:', err);
            setError(err.message);
        }
    };

    const handleCreateCheckIn = async () => {
        console.log('创建新的打卡记录...');
        try {
            const response = await axios.post('/checkIns', newCheckIn);
            console.log('创建的打卡记录:', response.data);
            setNewCheckIn({ name: '', rewardId: null });
            fetchCheckIns();
        } catch (err) {
            console.error('创建打卡记录时出错:', err);
            setError(err.message);
        }
    };

    const handleUpdateCheckIn = async (id) => {
        console.log(`更新ID为 ${id} 的打卡记录...`);
        try {
            const response = await axios.put(`/checkIns/${id}`, editingCheckIn);
            console.log('更新的打卡记录:', response.data);
            setEditingCheckIn(null);
            fetchCheckIns();
        } catch (err) {
            console.error(`更新ID为 ${id} 的打卡记录时出错:`, err);
            setError(err.message);
        }
    };

    const handleDeleteCheckIn = async (id) => {
        console.log(`删除ID为 ${id} 的打卡记录...`);
        try {
            const response = await axios.delete(`/checkIns/${id}`);
            console.log('删除的打卡记录:', response.data);
            fetchCheckIns();
        } catch (err) {
            console.error(`删除ID为 ${id} 的打卡记录时出错:`, err);
            setError(err.message);
        }
    };

    const handleCompleteCheckIn = async (id) => {
        console.log(`完成ID为 ${id} 的打卡记录...`);
        try {
            const response = await axios.put(`/checkIns/${id}`, { isCompleted: true });
            console.log('完成的打卡记录:', response.data);
            fetchCheckIns();
        } catch (err) {
            console.error(`完成ID为 ${id} 的打卡记录时出错:`, err);
            setError(err.message);
        }
    };

    return (
        <div className="container">
            <h2 className="my-4">打卡管理</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title">创建新打卡记录</h5>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="打卡名称"
                            value={newCheckIn.name}
                            onChange={(e) => setNewCheckIn({ ...newCheckIn, name: e.target.value })}
                        />
                    </div>
                    <button className="btn btn-primary" onClick={handleCreateCheckIn}>
                        创建打卡记录
                    </button>
                </div>
            </div>
            <div className="row">
                {checkIns.map((checkIn) => (
                    <div key={checkIn._id} className="col-md-4 mb-4" ref={(el) => (checkInRefs.current[checkIn._id] = el)}>
                        <div className={`card ${checkIn.isCompleted ? 'bg-success text-white' : 'bg-info text-white'}`}>
                            <div className="card-body">
                                {editingCheckIn && editingCheckIn._id === checkIn._id ? (
                                    <>
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editingCheckIn.name}
                                                onChange={(e) => setEditingCheckIn({ ...editingCheckIn, name: e.target.value })}
                                            />
                                        </div>
                                        <button className="btn btn-success" onClick={() => handleUpdateCheckIn(checkIn._id)}>
                                            更新打卡记录
                                        </button>
                                        <button className="btn btn-secondary" onClick={() => setEditingCheckIn(null)}>
                                            取消
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <h5 className="card-title">{checkIn.name}</h5>
                                        <div className="d-flex justify-content-between">
                                            <button className="btn btn-primary me-2" onClick={() => setEditingCheckIn(checkIn)}>
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button className="btn btn-danger" onClick={() => handleDeleteCheckIn(checkIn._id)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                        {!checkIn.isCompleted && (
                                            <button className="btn btn-success mt-3" onClick={() => handleCompleteCheckIn(checkIn._id)}>
                                                <FontAwesomeIcon icon={faCheck} /> 完成打卡
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CheckInManager;
